import React from "react";
import { Avatar, List } from "antd";
import "./styles.css";

const AvatarListing = ({ options, onListItemClick, optionValueList }) => {
  return (
    <List
      className="avatar-listing"
      dataSource={options}
      renderItem={(item) => {
        let value = null;
        const { consumerDetail, link, verified } = item;

        value = optionValueList.find(
          (optionKey) => optionKey[consumerDetail[0]]
        );

        return (
          <List.Item
            key={item.imgSrc}
            className={`${link ? "pointer" : ""}`}
            onClick={() => onListItemClick(link)}
          >
            <List.Item.Meta
              avatar={<Avatar src={item.imgSrc} />}
              title={item.label}
              description={value && value[consumerDetail[0]]}
            />
            {verified && (
              <div className="check-status">
                <img src="/assets/icons/success.svg" alt="verified" />
              </div>
            )}
          </List.Item>
        );
      }}
    />
  );
};

export default AvatarListing;
